<template>
  <div :data-testid="dataTestid" class="fixed top-0 flex w-full z-[2147483000] border-semantic-secondary-default bg-semantic-inverse-surface-light lg:border-b pt-safe drop-shadow-sm-1 ">
    <div class="flex flex-row flex-nowrap items-center justify-between h-full w-full mx-4 mt-2 mb-3">
      <div class="h-full flex flex-none justify-start">
        <AtomsButtonBack
          v-if="!isDashboardPage && !hideToolbarBackButton"
          class="min-h-11"
          theme="white"
          @click="goBack"
        />
        <NuxtLink
          v-else
          to="/dashboard/account-settings/"
        >
          <MoleculesNavProfile
            class="min-h-12 max-w-12"
            icon-only
            dropdown-position="left"
            icon-position="left"
            :has-background-when-active="false"
            :show-dropdown="false"
          />
        </NuxtLink>
      </div>
      <div class="flex-grow hidden xxxs:flex justify-center">
        <nuxt-link
          v-if="isDashboardPage"
          to=""
          class="flex mx-auto h-full">
          <img
            height="23"
            width="140"
            class="max-w-[9rem] xs:max-w-unset lg:w-auto m-auto"
            src="/images/cc-logo-white-text.svg"
            alt="Compare Club"
          />
        </nuxt-link>
      </div>
      <div v-if="isDashboardPage" class="flex-none h-full flex justify-end">
        <ul class="flex items-center h-full w-full justify-between">
          <MoleculesNavNotification v-if="enableContentCardNotifications" class="float-right my-auto h-full"/>
          <atoms-menu-item
            id="pwa_intercom_launcher"
            padding="none"
            theme="global-navbar"
            class="menu-other min-w-8 flex justify-center mr-1"
            :has-background-when-active="false"
          >
            <div class="rounded-full w-10 h-10 border-semantic-inverse-container-lowest border flex items-center justify-center hover:bg-semantic-inverse-container-lowest hover:text-semantic-inverse-primary">
              <svg
                class="fill-current"
                width="21"
                height="21"
                viewBox="0 0 21 21"
                fill="none"
                xmlns="http://www.w3.org/2000/svg">
                <path
                  fill-rule="evenodd"
                  clip-rule="evenodd"
                  d="M10.75 1.79634C6.08339 1.79634 2.36067 5.38178 2.36067 9.73216C2.36067 14.0825 6.08339 17.668 10.75 17.668C11.3949 17.668 12.0221 17.5992 12.624 17.4693C12.8527 17.42 13.0853 17.4663 13.2735 17.5859C13.7657 17.8985 14.8516 18.3539 16.6363 18.5154C16.3203 17.9395 16.0428 17.2181 15.9788 16.4224C15.9553 16.1311 16.0823 15.8641 16.2869 15.6939C18.0423 14.2337 19.1393 12.1005 19.1393 9.73216C19.1393 5.38178 15.4165 1.79634 10.75 1.79634ZM1.00024 9.73216C1.00024 4.56553 5.39864 0.435913 10.75 0.435913C16.1013 0.435913 20.4997 4.56553 20.4997 9.73216C20.4997 12.4388 19.2867 14.8686 17.365 16.5616C17.4925 17.3497 17.9044 18.0617 18.2529 18.5061C18.48 18.7957 18.4802 19.1542 18.3591 19.4194C18.2359 19.6894 17.9479 19.9398 17.5496 19.9296C15.1766 19.8687 13.5919 19.3377 12.718 18.8388C12.0818 18.9632 11.4235 19.0284 10.75 19.0284C5.39864 19.0284 1.00024 14.8988 1.00024 9.73216Z"
                  fill=""
                  stroke=""
                  stroke-width="0.5"/>
                <path d="M7.99976 10.4359C7.99976 10.9882 7.55204 11.4359 6.99976 11.4359C6.44747 11.4359 5.99976 10.9882 5.99976 10.4359C5.99976 9.88363 6.44747 9.43591 6.99976 9.43591C7.55204 9.43591 7.99976 9.88363 7.99976 10.4359Z" fill=""/>
                <path d="M11.9999 10.4359C11.9999 10.9882 11.5522 11.4359 10.9999 11.4359C10.4476 11.4359 9.99988 10.9882 9.99988 10.4359C9.99988 9.88363 10.4476 9.43591 10.9999 9.43591C11.5522 9.43591 11.9999 9.88363 11.9999 10.4359Z" fill=""/>
                <path d="M15.9999 10.4359C15.9999 10.9882 15.5522 11.4359 14.9999 11.4359C14.4476 11.4359 13.9999 10.9882 13.9999 10.4359C13.9999 9.88363 14.4476 9.43591 14.9999 9.43591C15.5522 9.43591 15.9999 9.88363 15.9999 10.4359Z" fill=""/>
              </svg>
            </div>
          </atoms-menu-item>
        </ul>
      </div>
    </div>
  </div>
</template>

<script setup>
defineOptions({
  name: 'OrganismsNavPwaMobileMenu'
})

defineProps({
  dataTestid: {
    type: String,
    default: ''
  }
})

const { enableContentCardNotifications } = useRuntimeConfig().public
const route = useRoute()
const router = useRouter()
const { $bus } = useNuxtApp()
const isDashboardPage = computed(() => {
  return ['dashboard','dashboard-quotes','dashboard-rewards','dashboard-perks','dashboard-ai-advisor'].includes(route.name)
})

const quickCompareHealthLoading = useState('quick-compare-health:loading', () => false)

const hideToolbarBackButton = computed(() => {
  const isQuickCompareHealthPage = String(route.name || '').includes('dashboard-quick-compare-health')
  return isQuickCompareHealthPage && quickCompareHealthLoading.value
})

const vaultStore = useVaultStore()
const goBack = () => {
  if (vaultStore.isInlineEdit) {
    router.push('/dashboard/').then(() => {
      vaultStore.resetInlineEdit()
    })
    return
  }

  const step = parseInt(route?.params?.step)

  if(step === 2 && vaultStore.vaultFormData?.product_type && route?.path?.includes('energy')) {
    router.push('/dashboard/')
    return
  }
  if(step === 1 && route?.path?.includes('/vault/form/')) {
    router.push('/dashboard/')
    return
  }
  if(route.name === 'dashboard-login') {
    const psRegistration = useState('psRegistration')
    if(psRegistration){
      $bus.emit('reset-login',true)
    }
  } else if (window?.history?.length > 1) {
    router.back()
  } else if(router){
    router.push('/dashboard/')
  } else {
    location.reload()
  }
}
</script>
